var React = require('react');

function Settings (props) {
    return React.createElement("svg",props,React.createElement("g",null,[React.createElement("path",{"fill":"none","stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","d":"\n\t\tM15.1,7.6l-1.5-0.8c-0.2-0.7-0.5-1.4-0.9-2l0.5-1.5c0.1-0.3-0.2-0.6-0.5-0.5l-1.5,0.5c-0.6-0.4-1.3-0.7-2.1-0.9L8.4,0.9\n\t\tc-0.2-0.3-0.6-0.3-0.8,0L6.9,2.3C6.1,2.4,5.4,2.7,4.8,3.2L3.3,2.6C3,2.5,2.7,2.8,2.8,3.2l0.5,1.4C2.8,5.2,2.5,6,2.3,6.8L0.9,7.6\n\t\tc-0.3,0.2-0.3,0.6,0,0.8l1.4,0.8c0.1,0.7,0.4,1.4,0.8,2l-0.5,1.6c-0.1,0.3,0.2,0.6,0.5,0.5l1.6-0.5c0.6,0.4,1.3,0.7,2,0.8l0.7,1.4\n\t\tc0.2,0.3,0.6,0.3,0.8,0l0.7-1.4c0.9-0.1,1.7-0.5,2.3-0.9l1.5,0.5c0.3,0.1,0.6-0.2,0.5-0.5l-0.5-1.5c0.4-0.6,0.7-1.4,0.9-2.2\n\t\tl1.4-0.7C15.5,8.2,15.5,7.7,15.1,7.6z","key":0}),React.createElement("circle",{"fill":"none","stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","cx":"8","cy":"8","r":"2.7","key":1})]));
}

Settings.displayName = "Settings";

Settings.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","viewBox":"0 0 16 16","enableBackground":"new 0 0 16 16","xmlSpace":"preserve"};

module.exports = Settings;

Settings.default = Settings;



//////////////////
// WEBPACK FOOTER
// ../icon/src/icons/settings.svg
// module id = ../icon/src/icons/settings.svg
// module chunks = 0